import * as React from 'react'
import { Card, CardContent } from './card'
import { Text } from './typography'
import { LucideIcon, Info } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './tooltip'

interface MetricCardProps {
  icon: LucideIcon
  title: string
  metric: React.ReactNode
  description: string
  info?: string
  className?: string
}

export function MetricCard({
  icon: Icon,
  title,
  metric,
  description,
  info,
  className,
}: MetricCardProps) {
  return (
    <Card className={cn('border-border', className)}>
      <CardContent className="p-3 relative">
        <div className="absolute -top-2 -left-2 p-1.5 rounded-lg bg-muted border border-border">
          <Icon className="h-4 w-4 text-muted-foreground" />
        </div>
        <Text
          variant="body"
          weight="medium"
          className="text-foreground text-center mb-2 mt-2"
        >
          {title}
        </Text>
        <div className="flex items-center justify-center gap-2 mb-2">
          {typeof metric === 'string' || typeof metric === 'number' ? (
            <Text variant="metric" className="text-center">
              {metric}
            </Text>
          ) : (
            metric
          )}
        </div>
        <div className="text-center text-sm text-muted-foreground [text-wrap:pretty]">
          {description}
          {info && (
            <span className="inline-block whitespace-nowrap">
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Info
                      className="inline-block h-4 w-4 text-muted-foreground cursor-help ml-1.5 -mt-0.5 align-middle"
                      aria-label="More information"
                    />
                  </TooltipTrigger>
                  <TooltipContent
                    side="bottom"
                    className="max-w-[220px] whitespace-wrap"
                  >
                    <span className="text-xs text-left w-full block relative">
                      {info}
                    </span>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </span>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
